import React, { useState } from "react";
import { IoSearchOutline } from "react-icons/io5";
import { getApiInstance } from "../../../utils/api";
import "./inputSearch.scss";

const InputSearch = ({ context, onSearch, placeholder }) => {
    const [query, setQuery] = useState("");
    const [results, setResults] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [latestSearches, setLatestSearches] = useState([
        "'Mueble Fila Accesorios'",
        "'Burra Perimetral'",
        "'Armario Dintel'",
    ]);
    const [favoriteSearches, setFavoriteSearches] = useState([
        "'Armario Enchufe'",
        "'Pantalla Control Probadores'",
        "'Probador Circular'",
        "'Balda Cremalleras'",
        "'Pincho Baño'",
    ]);

    const handleChange = async (event) => {
        const value = event.target.value;
        setQuery(value);

        if (context === "tableSearch" && onSearch) {
            onSearch(value);
        }

        if (!value.trim()) {
            setResults([]);
            return;
        }

        try {
            const api = await getApiInstance();
            const response = await api.get("/api/Mueble/BuscarMuebles", {
                params: {
                    searchTerm: value,
                },
            });

            setResults(response.data);
        } catch (error) {
            console.error("Error fetching search results:", error);
            setResults([]);
        }
    };

    const openModal = () => {
        if (context === "mainSearch") {
            setShowModal(true);
        }
    };

    const closeModal = () => {
        setShowModal(false);
    };

    return (
        <div className="search">
            <div className="search__input-wrapper">
                <IoSearchOutline className="search__icon" />
                <input
                    type="text"
                    value={query}
                    onChange={handleChange}
                    placeholder={placeholder}
                    className="search__input"
                    onClick={openModal}
                />
            </div>
            {showModal && context === "mainSearch" && (
                <div className="search__modal">
                    <div className="search__modal__content">
                        <span className="close" onClick={closeModal}>
                            &times;
                        </span>
                        <div className="search__modal__content__header">
                            <input
                                type="text"
                                value={query}
                                onChange={handleChange}
                                placeholder="Buscar productos..."
                                className="search__modal__content__header__input"
                            />
                        </div>
                        <div className="modal-body">
                            <div className="modal-column">
                                <h3>Tus búsquedas anteriores</h3>
                                <ul>
                                    {latestSearches.map((item, index) => (
                                        <li key={index}>{item}</li>
                                    ))}
                                </ul>
                            </div>
                            <div className="modal-column">
                                <h3>Tus favoritos</h3>
                                <ul>
                                    {favoriteSearches.map((item, index) => (
                                        <li key={index}>{item}</li>
                                    ))}
                                </ul>
                            </div>
                            <div className="modal-column">
                                <h3>Resultados para "{query}"</h3>
                                <div className="results-list">
                                    {results.length > 0 ? (
                                        results.map((result, index) => (
                                            <div
                                                key={index}
                                                className="result-item"
                                            >
                                                <img
                                                    src={result.image}
                                                    alt={result.title}
                                                />
                                                <p>{result.title}</p>
                                                <p>{result.material}</p>
                                                <p>{result.reference}</p>
                                            </div>
                                        ))
                                    ) : (
                                        <p>
                                            No se encontraron resultados para "
                                            {query}"
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default InputSearch;
